/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Shop_Slug_InvalidInputs */

const vi_error_shop_slug_invalid = /** @type {(inputs: Error_Shop_Slug_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chỉ dùng chữ thường không dấu, số và dấu gạch ngang giữa các từ (vd che-tom-non), tối đa ${i?.max} ký tự.`)
};

/**

* @param {Error_Shop_Slug_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_slug_invalid = /** @type {((inputs: Error_Shop_Slug_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Slug_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_slug_invalid(inputs)
});